import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import "react-table/react-table.css";
import couterpart from 'counterpart';

import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import WorkOrderDataService from '../services/WorkOrderDataService';
import WorkOrderUtil from '../utilities/WorkOrderUtil';
import AuthenticationService from '../services/AuthenticationService';
import { WO_DESIGN } from '../constants';

class CardByStatus extends Component {
  constructor() {
    super();
    this.state = {
      count: 0,
      status: 0,
      allStatus: []
    };
  }

  componentDidMount() {
    let errCode = this.props.error ? this.props.error.errorCode : 0;
    if (errCode > 0) {
      WorkOrderDataService.countByStatusAndErrorCode(`${this.props.info.status}`, errCode).then(data => {
        // console.log('Count by status', data)
        this.setState({
          status: this.props.info.status,
          count: data ? data : 0,
          errorCode: errCode
        });
      });
    } else {
      if (this.props.info.hoanthanh !== undefined && this.props.info.hoanthanh >= 0){
        WorkOrderDataService.countByStatusKcs(`${this.props.info.status}`, this.props.info.hoanthanh).then(data => {
          this.setState({
            status: this.props.info.status,
            count: data ? data : 0,
            hoanthanh: this.props.info.hoanthanh
          });
        });
      } else {
        WorkOrderDataService.countByStatus(`${this.props.info.status}`).then(data => {
          // console.log('Count by status', data)
          this.setState({
            status: this.props.info.status,
            count: data ? data : 0,
            errorCode: errCode
          });
        });
      }
    }
    // MasterDataService.retrieveAllStatus().then(data => {
    //     this.setState({ allStatus:  data}) 
    // });
  }

  viewDetails() {
    sessionStorage.removeItem('prod.fromDate');
    sessionStorage.removeItem('wo.fromDate');
    sessionStorage.removeItem('wo.selectedPage');
    if (AuthenticationService.isDesigner()) {
      WorkOrderUtil.saveItem('wo.woStatus', this.state.status);
      if (this.state.status === WO_DESIGN) {
        WorkOrderUtil.saveItem('wo.includeImage', 0);
      }

      this.props.history.push("/workOrders?status=" + this.state.status);
      return;
    }

    let statusDesc = WorkOrderUtil.getStatusDescription(this.props.allStatus, this.state.status);

    if (AuthenticationService.isAdmin() || AuthenticationService.isService()) {
      WorkOrderUtil.saveItem('prod.woStatus', this.state.status);
      WorkOrderUtil.saveItem('prod.selectedWoStatusList', JSON.stringify([{ id: this.state.status, name: statusDesc }]));
      this.props.history.push("/products?status=" + this.state.status);
      return;
    }

    if (AuthenticationService.isKhac()) {
      WorkOrderUtil.saveItem('prodKhac.workerName', '');
      WorkOrderUtil.saveItem('prodKhac.incident', '');
      WorkOrderUtil.saveItem('prodKhac.selectedWoStatusList', JSON.stringify([{ id: this.state.status, name: statusDesc }]));
      this.props.history.push("/khacs?status=" + this.state.status);
      return;
    }

    if (AuthenticationService.isKim()) {

      return;
    }

    if (AuthenticationService.isXi()) {
      WorkOrderUtil.saveItem('prodXi.workerName', '');
      WorkOrderUtil.saveItem('prodXi.selectedWoStatusList', JSON.stringify([{ id: this.state.status, name: statusDesc }]));
      WorkOrderUtil.saveItem('prodXi.selectedWoErrorList', JSON.stringify([{ errorCode: this.state.errorCode }]));
      this.props.history.push("/xis?status=" + this.state.status);
      return;
    }

    if (AuthenticationService.isKcs()) {
      WorkOrderUtil.saveItem('kcs.hoanthanh', this.state.hoanthanh);
      WorkOrderUtil.saveItem('kcs.woStatus', this.state.status);
      WorkOrderUtil.saveItem('kcs.selectedWoStatusList', JSON.stringify([{ id: this.state.status, name: statusDesc }]));
      this.props.history.push("/hoanthanh?status=" + this.state.status);
      return;
    }
  }

  render() {
    if (this.props.info === undefined) {
      return (<></>);
    }
    let statusDesc = WorkOrderUtil.getStatusDescription(this.props.allStatus, this.state.status);
    if (AuthenticationService.isKim()) {
      return (
        <Card style={{ width: '18rem' }}>
          {/* <Card.Img variant="top" src="holder.js/100px180" /> */}
          <Card.Body>
            <Card.Title> {this.props.title ? this.props.title : statusDesc}</Card.Title>
            <Card.Text>
              {this.state.count}
            </Card.Text>
          </Card.Body>
        </Card>
      )
    }

    if (AuthenticationService.isBong()) {
      return (
        <Card style={{ width: '18rem' }}>
          {/* <Card.Img variant="top" src="holder.js/100px180" /> */}
          <Card.Body>
            <Card.Title> {this.props.title ? this.props.title : statusDesc}</Card.Title>
            <Card.Text>
              {this.state.count}
            </Card.Text>
          </Card.Body>
        </Card>
      )
    }
    return (
      <Card style={{ width: '18rem' }}>
        {/* <Card.Img variant="top" src="holder.js/100px180" /> */}
        <Card.Body>
          <Card.Title> {this.props.title ? this.props.title : statusDesc}</Card.Title>
          <Card.Text>
            {this.state.count}
          </Card.Text>
          <Button className="myButton" onClick={this.viewDetails.bind(this)}>{couterpart.translate('wo_goto_details')}</Button>
        </Card.Body>
      </Card>
    )
  }
}

export default withRouter(CardByStatus);